class operator {
  constructor(
    operId,
    login,
    nombre,
    fecAlta,
    fecBaja,
    dbGrupo,
    ws,
    correoE,
    empleados,
    grupos,
    roles,
    unnegocios,
    token
  ) {
    this.operId = operId;
    this.login = login === null ? "" : login;
    this.nombre = nombre === null ? "" : nombre;
    this.fecAlta = fecAlta;
    this.fecBaja = fecBaja;
    this.dbGrupo = dbGrupo === null ? "" : dbGrupo;
    this.ws = ws;
    this.correoE = correoE === null ? "" : correoE;
    this.empleados = empleados;
    this.grupos = grupos;
    this.roles = roles;
    this.unnegocios = unnegocios;
    this.token = token === undefined ? "" : token;
  }
  static fromJson({
    operId,
    login,
    nombre,
    fecAlta,
    fecBaja,
    dbGrupo,
    ws,
    correoE,
    empleados,
    grupos,
    roles,
    unnegocios,
    token,
  }) {
    return new operator(
      operId,
      login,
      nombre,
      fecAlta,
      fecBaja,
      dbGrupo,
      ws,
      correoE,
      empleados,
      grupos,
      roles,
      unnegocios,
      token
    );
  }
}
export default operator;
